export enum EnrollmentTier {
    Advanced = 1,
    Basic = 2,
    Lite = 3,
    Standard = 4,
    AdvancedV2 = 5,
    Complete = 6,
    Irrigation = 7,
    Monitoring = 8,
    Preview = 9,
}

export const NOT_ENROLLED_TIER_KEY = "not_enrolled";

export function getEnrollmentTierLabel(
    enrollmentTier: number | EnrollmentTier | undefined,
    t?: (key: string) => string,
) {
    if (!enrollmentTier)
        return t ? t("enrollment_tiers.not_enrolled") : "Not Enrolled";

    const labels = {
        1: t ? t("enrollment_tiers.advanced") : "Advanced (2025)",
        2: t ? t("enrollment_tiers.basic") : "Basic",
        3: t ? t("enrollment_tiers.lite") : "Lite",
        4: t ? t("enrollment_tiers.standard") : "Standard",
        5: t ? t("enrollment_tiers.advanced") : "Advanced", // ADVANCED_V2 original basic/advanced (1/2) are folded into this new advanced tier
        6: t ? t("enrollment_tiers.complete") : "Complete",
        7: t ? t("enrollment_tiers.irrigation") : "Irrigation",
        8: t ? t("enrollment_tiers.monitoring") : "Monitoring",
        9: t ? t("enrollment_tiers.preview") : "Preview",
    };

    return labels[enrollmentTier as keyof typeof labels];
}
export const TIER_OPTIONS = [
    {
        label: getEnrollmentTierLabel(EnrollmentTier.Preview),
        tier: EnrollmentTier.Preview,
    },
    {
        label: getEnrollmentTierLabel(EnrollmentTier.Irrigation),
        tier: EnrollmentTier.Irrigation,
    },
    {
        label: getEnrollmentTierLabel(EnrollmentTier.Standard),
        tier: EnrollmentTier.Standard,
    },
    {
        label: getEnrollmentTierLabel(EnrollmentTier.Monitoring),
        tier: EnrollmentTier.Monitoring,
    },
    {
        label: getEnrollmentTierLabel(EnrollmentTier.AdvancedV2),
        tier: EnrollmentTier.AdvancedV2,
    },
    {
        label: getEnrollmentTierLabel(EnrollmentTier.Complete),
        tier: EnrollmentTier.Complete,
    },
];

export function passesTierFilter(
    activeEnrollment: { enrollment_tier: number } | null | undefined,
    enrollmentTier?: string | null,
) {
    if (!enrollmentTier) return true;
    if (enrollmentTier === NOT_ENROLLED_TIER_KEY) return !activeEnrollment;

    const tier = Number(enrollmentTier);
    if (Number.isNaN(tier)) return true;

    return activeEnrollment?.enrollment_tier === tier;
}

export function getRetailPrice(tier: EnrollmentTier) {
    return {
        [EnrollmentTier.Advanced]: 9.0,
        [EnrollmentTier.Basic]: 6.5,
        [EnrollmentTier.Lite]: 0,
        [EnrollmentTier.Standard]: 4.0,
        [EnrollmentTier.AdvancedV2]: 7.0,
        [EnrollmentTier.Complete]: 10.0,
        [EnrollmentTier.Irrigation]: 4.0,
        [EnrollmentTier.Monitoring]: 2.0,
        [EnrollmentTier.Preview]: 1.5,
    }[tier];
}

export enum RequestHelpType {
    request_refund = "request_refund",
    request_help = "request_help",
    request_enrollment_update = "request_enrollment_change",
    request_balance_update = "request_balance_update",
}
